import { FieldErrors } from "react-hook-form";
import { FormData } from "./form-page";
import { FormErrorData } from "src/types/analytics";
import { CreditDecision } from "./make-credit-decision/make-credit-decision.types";
import { submitCreditApplication } from "./make-credit-decision/make-credit-decision.service";
import { logCreditDecisionSuccess, logCreditDecisionFailure } from "src/lib/logger";
import { parseFormErrors } from "src/utils/form-error-parser";

interface HandleFormSubmitParams {
    correlationId: string;
    formData: FormData;
    setFetching: (fetching: boolean) => void;
    setSubmitError: (error: string | null) => void;
    onSubmitSuccess: (result: { result: CreditDecision; customerName: string }) => void;
}

interface HandleInvalidSubmitParams {
    errors: FieldErrors;
    trackFormErrorsOnSubmission: (fieldErrors: FormErrorData) => void;
}

export const handleValidFormSubmit = ({
    correlationId,
    formData,
    setFetching,
    setSubmitError,
    onSubmitSuccess,
}: HandleFormSubmitParams) => {
    setFetching(true);
    setSubmitError(null);

    submitCreditApplication(correlationId, formData)
        .then((decision) => {
            logCreditDecisionSuccess(correlationId, decision);
            onSubmitSuccess({ result: decision, customerName: formData.firstName });
        })
        .catch((e) => {
            logCreditDecisionFailure(correlationId, e);
            setSubmitError(e.message);
        })
        .finally(() => setFetching(false));
};

export const handleInvalidFormSubmit = ({ errors, trackFormErrorsOnSubmission }: HandleInvalidSubmitParams) => {
    const fieldErrors = parseFormErrors(errors);

    if (fieldErrors.length > 0) {
        trackFormErrorsOnSubmission(fieldErrors);
    }
};
